"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = require("lodash");

var _cleanEmptyObject = _interopRequireDefault(require("./clean-empty-object"));

/**
 * External dependencies
 */

/**
 * Internal dependencies
 */

/**
 * Migrates the current style.typography.fontFamily attribute,
 * whose value was "var:preset|font-family|helvetica-arial",
 * to the style.fontFamily attribute, whose value will be "helvetica-arial".
 *
 * @param {Object} attributes The current attributes
 * @return {Object} The updated attributes.
 */
function _default(attributes) {
  var _attributes$style, _attributes$style$typ;

  if (!(attributes !== null && attributes !== void 0 && (_attributes$style = attributes.style) !== null && _attributes$style !== void 0 && (_attributes$style$typ = _attributes$style.typography) !== null && _attributes$style$typ !== void 0 && _attributes$style$typ.fontFamily)) {
    return attributes;
  } // Clone first so when we delete the fontFamily
  // below we're not modifying the original
  // attributes. Because the deprecation may be discarded
  // we don't want to alter the original attributes.


  const atts = (0, _lodash.cloneDeep)(attributes);
  const fontFamily = atts.style.typography.fontFamily.split('|').pop();
  delete atts.style.typography.fontFamily;
  atts.style = (0, _cleanEmptyObject.default)(atts.style);
  return { ...atts,
    fontFamily
  };
}
//# sourceMappingURL=migrate-font-family.js.map